// extracted by mini-css-extract-plugin
export default {"footer":"InputBar_footer__kW8Am","btn":"InputBar_btn__WvrN2","icon":"InputBar_icon__PYEV8"};